import '../assets/NcAppNavigationCaption-zgtPq3Od.css';
import { N as NcActions } from "./NcActions-BgYpDq2n.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const _sfc_main = {
  name: "NcAppNavigationCaption",
  components: {
    NcActions
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      required: true
    },
    /**
     * `id` to set on the inner caption
     * Can be used for connecting the `NcActionCaption` with `NcActionList` using `aria-labelledby`.
     */
    headingId: {
      type: String,
      default: null
    },
    /**
     * Enable when used as a heading
     * e.g. Before NcAppNavigationList
     */
    isHeading: {
      type: Boolean,
      default: false
    },
    /**
     * If `isHeading` is set, this defines the heading level that should be used
     */
    headingLevel: {
      type: Number,
      default: 2
    },
    /**
     * Any [NcActions](#/Components/NcActions?id=ncactions-1) prop
     */
    // Not an actual prop but needed to show in vue-styleguidist docs
    // eslint-disable-next-line
    " ": {}
  },
  computed: {
    wrapperTag() {
      return this.isHeading ? "div" : "li";
    },
    captionTag() {
      const headingLevel = Math.max(2, this.headingLevel);
      return this.isHeading ? "h".concat(headingLevel) : "span";
    },
    // Check if the actions slot is populated
    hasActions() {
      return !!this.$slots.actions;
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c(_vm.wrapperTag, { tag: "component", staticClass: "app-navigation-caption", class: { "app-navigation-caption--heading": _vm.isHeading } }, [_c(_vm.captionTag, { tag: "component", staticClass: "app-navigation-caption__name", attrs: { "id": _vm.headingId } }, [_vm._v(" " + _vm._s(_vm.name) + " ")]), _vm.hasActions ? _c("div", { staticClass: "app-navigation-caption__actions" }, [_c("NcActions", _vm._g(_vm._b({ scopedSlots: _vm._u([{ key: "icon", fn: function() {
    return [_vm._t("actionsTriggerIcon")];
  }, proxy: true }], null, true) }, "NcActions", _vm.$attrs, false), _vm.$listeners), [_vm._t("actions")], 2)], 1) : _vm._e()], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "af6cfb9c"
);
const NcAppNavigationCaption = __component__.exports;
export {
  NcAppNavigationCaption as N
};
